module.exports = __webpack_public_path__ + "static/media/addMemberGuide4.03783f80.png";